import React, { useEffect } from 'react';
import { sendTrackingInfo } from '@panel/commons';
import { useTranslation } from 'react-i18next';
import { ModalInformation } from '@panel/commons/lib/Modals/ModalInformation';

function NormalFlowOffToOnCreditsNoEcomNo(props) {
  const { onClickAction } = props;
  const { t } = useTranslation();
  useEffect(() => {
    sendTrackingInfo('Mis avisos', 'Republicar Aviso_sin credito-Intencion');
  }, []);
  return (
    <ModalInformation
      onClickAction={onClickAction}
      onClickOutside={onClickAction}
      title={t('panel.modal.NormalFlowOffToOnCreditsNoEcomNo.title')}
      message={`${t('panel.modal.NormalFlowOffToOnCreditsNoEcomNo.text')}`}
      linkTel={t('panel.sales.phoneNumber')}
      linkTelRef={t('panel.sales.phoneNumberRef')}
      linkTel2={t('panel.sales.phoneNumber.2')}
      linkTelRef2={t('panel.sales.phoneNumberRef.2')}
      linkTelText={t('panel.sales.city.1')}
      linkTelText2={t('panel.sales.city.2')}
      ctaOk={t('panel.modal.cta.ok')}
    />
  );
}

export { NormalFlowOffToOnCreditsNoEcomNo };
